import React, { useEffect } from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Box,
  Grid,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { buildShopPath } from "../../utils/functionalOperations";
import StarIcon from "@mui/icons-material/Star";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const ShopCard = ({ shop }) => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const handleShopNow = () => {
    navigate(buildShopPath(shop), { state: { shop } });
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 4,
      }}
    >
      <Card
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          padding: 2,
          width: "100%",
          maxWidth: { xs: "100%", md: 1280 },
          width: "100%",
          boxShadow: 3,
          borderRadius: 2,
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            padding: "4px 8px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <StarIcon sx={{ color: "#FFA500", fontSize: 18 }} />
          <Typography
            variant="body2"
            sx={{ marginLeft: 0.5, color: "#FFA500" }}
          >
            {shop.rating}
          </Typography>
        </Box>
        <CardMedia
          component="img"
          sx={{
            width: { xs: "100%", sm: 300 },
            height: { xs: 180, sm: 220 },
            borderRadius: 2,
            objectFit: "cover",
          }}
          image={shop.image}
          alt={shop.name}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            marginLeft: { xs: 0, sm: 2 },
            marginTop: { xs: 2, sm: 0 },
          }}
        >
          <CardContent>
            <Typography variant="h6" component="div">
              {shop.shopName}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                display: "inline-block",
                padding: "2px 8px",
                borderRadius: "5px",
                marginBottom: 1,
                backgroundColor: "#FFF4E5",
                color: "#FF6F00",
              }}
            >
              {shop.description}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                display: "flex",
                alignItems: "center",
                marginTop: 1,
              }}
            >
              <LocationOnIcon
                fontSize="small"
                sx={{ color: "#FF6F00", marginRight: 0.5 }}
              />
              {shop.distance}
              {/* <Typography
                variant="body2"
                sx={{
                  marginLeft: "auto",
                  color: "#007BFF",
                }}
              >
                Distance: Dynamic
              </Typography> */}
            </Typography>
          </CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              marginTop: "auto",
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#FF6F00",
                color: "#fff",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#E65C00",
                },
              }}
              size="small"
              onClick={handleShopNow}
            >
              Shop Now
            </Button>
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

const Categorys = () => {
  const { state } = useLocation();
  const { categoryid } = useParams();
  const vendors = state?.vendors || [];
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const visibleShopsCount = 9;
  // const visibleShops = vendors.slice(
  //   currentIndex,
  //   currentIndex + visibleShopsCount
  // );
  const visibleShops = vendors.slice(currentIndex);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <Box sx={{ maxWidth: "1200px", margin: "0 auto", padding: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "1rem", sm: "1.5rem", md: "1.75rem", lg: "1.7rem" },
            marginLeft: { xs: 0, md: 15, lg: 4 },
            marginTop: { xs: 0, md: 7 },
          }}
        >
          {/* {displayName.charAt(0).toUpperCase() + displayName.slice(1)} */}
        </Typography>
      </Box>
      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          marginBottom: 2,
          color: "#333",
          ml: { xs: 2, sm: 1, md: 5 },
        }}
      >
        Vendor Details
      </Typography>
      {vendors.length > 0 ? (
        <Grid container spacing={1}>
          {visibleShops.map((shop) => (
            <Grid item xs={12} key={shop.id}>
              <ShopCard shop={shop} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Typography sx={{ textAlign: "center", mt: 4, color: "gray" }}>
          No vendors found.Currently, we have services available only in the Secunderabad  location.
        </Typography>
      )}
    </Box>
  );
};

export default Categorys;
